import { mode } from '@chakra-ui/theme-tools';

type Dict = Record<string, any>;

const baseStyle = {
  color: 'white',
  borderRadius: 'full',
  fontSize: 'xs',
  fontWeight: '300',
  textTransform: 'uppercase',
  letterSpacing: 'wider',
  border: '1px solid',
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  px: [2, 3],
  py: [1, 1],
};

function variantOnline(props: Dict) {
  return {
    bg: mode('purple.500', 'purple.600')(props),
    bgGradient: 'linear(125deg, purple.400, purple.600)',
    borderColor: mode('purple.600', 'purple.500')(props),
    border: '2px solid',
  };
}

function variantStudio(props: Dict) {
  return {
    bg: mode('teal.500', 'teal.600')(props),
    bgGradient: 'linear(125deg, teal.400, teal.600)',
    borderColor: mode('teal.600', 'teal.500')(props),
    border: '2px solid',
  };
}

function variantMixed(props: Dict) {
  return {
    bg: mode('blue.500', 'blue.600')(props),
    bgGradient: 'linear(125deg, blue.400, blue.600)',
    borderColor: mode('blue.600', 'blue.500')(props),
    border: '2px solid',
  };
}

const variants = {
  online: variantOnline,
  studio: variantStudio,
  mixed: variantMixed,
};

const sizes = {
  sm: {
    paddingTop: '1px',
    fontSize: 'xs',
    px: 2,
    py: 1,
  },
  md: {
    paddingTop: '2px',
    fontSize: 'sm',
    px: 3,
    py: 1,
  },
  lg: {
    fontSize: 'md',
    px: 4,
    py: 2,
  },
};

const defaultProps = {
  size: 'sm',
  variant: 'solid',
};

export default {
  baseStyle,
  variants,
  sizes,
  defaultProps,
};
